import { useState } from 'react';

import { ButtonDrop } from './buttons.styled';

export const DropButton = (props) => {
  const { action, ...rest } = props;
  const [loading, setLoading] = useState(false);

  const click = () => {
    setLoading(true);
    action();
    // setTimeout(() => setLoading(false), 700);
  };

  const cl = loading ? 'loading' : '';

  return <ButtonDrop className={cl} onClick={click} {...rest} />;
};
